import { endsWith } from 'lodash';

// CONFIGS
const defaultConfig = {
  axios: {
    baseURL: __DEV__ ? 'http://localhost:8080/api' : '/api',
    timeout: 60 * 1000,
    withCredentials: true,
  },
  login: {
    baseURL: (__DEV__ || endsWith(window.location.host, 'socar.me')) ? 'https://api.socar.me' : 'https://api.socar.kr',
  },
  // sms인증
  server: {
    baseURL: (__DEV__ || endsWith(window.location.host, 'socar.me')) ? 'https://apis.socar.me/v4' : (endsWith(window.location.host, '-stg.socar.kr')) ? 'https://apis-stg.socar.kr/v4' : 'https://apis.socar.kr/v4',
    timeout: 20 * 1000,
    // withCredentials: true,
  },
  daumMap: {
    // 카카오API dev@socar.kr 계정 `SOCAR` 서비스 키
    appKey: '2885441ea74157f2a1671d324ca462fd',
  },
  amplitude: {
    apiKey: (__DEV__ || endsWith(window.location.host, 'socar.me')) ? 'b51dee374b53757c64575a7acd9c17bd' : '9961269157425dced587dbaa2ce0b013',
  },
  rentalHistory: {
    baseURL: (__DEV__ || endsWith(window.location.host, 'socar.me')) ? 'https://plan.socar.me/rental-history' : (endsWith(window.location.host, '-stg.socar.kr')) ? 'https://plan-stg.socar.kr/rental-history' : 'https://plan.socar.kr/rental-history',
  },
  planHome: {
    baseURL: (__DEV__ || endsWith(window.location.host, 'socar.me')) ? 'https://plan.socar.me' : (endsWith(window.location.host, '-stg.socar.kr')) ? 'https://plan-stg.socar.kr' : 'https://plan.socar.kr',
  },
};

export default defaultConfig;
